<!-- 由 suu 创建于 2025-03-20 星期四 -->
<template>
  <div class="test-upload">
    <div @click="bindUpload">上传图片</div>
  </div>
</template>

<script>
export default {
  name: 'test-upload',

  components: {},

  props: {},

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    bindUpload() {
      let self = this
      let obj = {
        callbackMethod: 'onRequestCamera'
      }
      window.onRequestCamera = (res) => {
        res = JSON.parse(res)
        if (!Array.isArray(res)) {
          self.$toast('获取图片失败')
        }
        const b64 = 'data:image/png;base64,' + res[0]
        self.$http
          .uploadImg(b64, 'test-upload')
          .then((res) => {
            console.log('上传成功', res)
          })
          .catch((err) => {
            console.log('上传失败', err)
          })
      }
      window.onAppCamera.postMessage(JSON.stringify(obj))
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.test-upload {
  padding-top: 40px;
  font-size: 30px;
}
</style>
